import { X } from '@squareup/dex-icons/market/action';
import { NullableClassName } from '@squareup/dex-types-shared-ui';
import { IconButton } from '@squareup/dex-ui';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './api-explorer-field-helpers.module.css';

const strings = {
  closeButtonLabel: 'Clear "{propertyName}" field',
};

interface Props {
  onClick: () => void;
  labelName: string;
}

const iconDim = 16;

const CloseButton: FC<Props & NullableClassName> = ({
  labelName,
  onClick,
  className,
}) => {
  const label = strings.closeButtonLabel.replace('{propertyName}', labelName);

  return (
    <IconButton
      testId="api-explorer-field-close-button"
      colorVariant="20"
      aria-label={label}
      containerClassName={clsx(styles['tooltip-content'], className)}
      width={iconDim}
      height={iconDim}
      tooltipText={label}
      icon={
        <X
          className={commonIconStyles['icon-fill-current-color']}
          width={iconDim}
          height={iconDim}
          viewBox="0 0 24 24"
        />
      }
      trackingId="property-info-close-button"
      onClick={onClick}
    />
  );
};

export { CloseButton };
